var React = require('react');

function ForYou (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M4.6,1h6.6c-0.1-0.6-0.4-1-1.1-1H5.7C5,0,4.6,0.3,4.6,1z M3.5,2.9h8.9c-0.1-0.7-0.4-1-1.2-1H4.6C3.9,1.9,3.6,2.3,3.5,2.9z\n\t\t M4.3,16h7.6c1.3,0,2.1-0.8,2.1-2.2V6.3c0-1.4-0.8-2.2-2.2-2.2H4.3C2.8,4.1,2,4.8,2,6.3v7.5C2,15.2,2.8,16,4.3,16z M4.4,14.5\n\t\tc-0.6,0-0.9-0.3-0.9-0.9V6.4c0-0.6,0.3-0.9,0.9-0.9h7.2c0.6,0,0.9,0.3,0.9,0.9v7.2c0,0.6-0.3,0.9-0.7,0.9H4.4z"})));
}

ForYou.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = ForYou;

ForYou.default = ForYou;
